import { Form } from '@anytag/shared-atoms';
import { Template, TemplateProps } from './Template';

export const RejectedInfluencers = (props: TemplateProps) => (
  // We're using same hook for selected/rejected influencers table - which is using RHF, so put empty Provider to avoid some undefined context values
  <Form.Provider>
    <Template {...props} />
  </Form.Provider>
);
